import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_kxk5df5zt5: FaireBrandEntity = {
  token: "b_kxk5df5zt5",
  type: "brand",
  name: "Noble Mick's - Craft Beverage Company",
  avatarUrl:
    "https://cdn.faire.com/fastly/97a42ac7370f2a74e250c80dc52d03de7cdc45f4415c0c1b1d6f3ddbef19e67f.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/6dca983ad755ecbf038c9ae09738df0323fa2c18b27e37b4dfe8350bcdac5d15.png",
  logoUrl:
    "https://cdn.faire.com/fastly/97a42ac7370f2a74e250c80dc52d03de7cdc45f4415c0c1b1d6f3ddbef19e67f.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6dca983ad755ecbf038c9ae09738df0323fa2c18b27e37b4dfe8350bcdac5d15.png",
  location: "Sparks, MD, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 67,
  isTopShop: true,
  isInsider: true,
  description:
    "It was a dark and stormy night in the basement of an abandoned warehouse...not really but I always wanted to start a story like that! Noble Mick's was the brainchild of owners Courtney and Erik. They have been successful business owners in the gift and home industry for over 16 years. Seeing a need in that marketplace for something new and exciting they set out to develop a product that filled that void.\n\nNothing brings people together more than a party. Whether its a cocktail (or Mocktail) with friends at the end of a long week or sitting around a campfire at a family camp out. We wanted to create something to make that easier. Not wanting to lug around liquid mixers or keeping tons of ingredients around the house. Noble Mick's makes starting a party anywhere, anytime a snap.\n\nWe have now successfully mixed a Noble Mick's cocktail just about everywhere you can imagine. On an airplane, in a hotel, camping, hiking, even in the parking lot at a kids trampoline park birthday party...don't judge us.\n\nFor us its all about the party. Bringing people we love and people we just met together. Keep the party going and tag us on social media or shoot us a message so we can enjoy too. Cheers! Erik and Courtney",
  meta: {
    source: "api",
    importedAt: "2026-08-11T20:07:18.798Z",
    importedBy: "entity-db-cli",
  },
};
